module.exports = __webpack_public_path__ + "img/1.1613f594.png";